import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'timeConvert'
})

export class TimeConvertPipe implements PipeTransform {
    transform(seconds: number): string {
        let totalTimeInSeconds = seconds ? Math.round(seconds) : 0;
        let hours = Math.floor(totalTimeInSeconds / 3600);
        let mins = Math.floor((totalTimeInSeconds % 3600) / 60);
        let secnds = Math.floor((totalTimeInSeconds % 3600) % 60);
        let result = (hours > 0 ? hours : 0).toString().padStart(2, '0') + ":" + (mins > 0 ? mins : 0).toString().padStart(2, '0') + ":" + (secnds > 0 ? secnds : 0).toString().padStart(2, '0') + " hr";
        return result;
    }
}

